import { render, staticRenderFns } from "./StackedRoomsFilter.vue?vue&type=template&id=065d731d"
import script from "./StackedRoomsFilter.vue?vue&type=script&lang=js"
export * from "./StackedRoomsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports